export default __webpack_public_path__ + "static/media/016.a1e5d5c6.jpg";